import { useState } from "react";
import video from "../../assests/video.mp4";
import { BiError } from "react-icons/bi";
import { AiFillCloseCircle } from "react-icons/ai";
import { MdWarning } from "react-icons/md";

export default function Popup({
  popUpInitialValue,
  handlePopup,
  image,
  content,
  buttontext,
  onClick,
}) {
  const closeThisPopUP = () => {
    handlePopup();
  };

  return (
    <>
      {popUpInitialValue ? (
        <div
          onClick={() => closeThisPopUP}
          className="absolute w-scaeen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="fixed text-start inset-0 bg-bg3 z-50 flex flex-col items-center justify-center  rounded  md:w-[40%] lg:w-[40%] w-[90%] h-[60vh] m-auto shadow-lg overflow-y-auto no-scrollbar"
          >
            <AiFillCloseCircle
              className="text-primary absolute text-2xl cursor-pointer  top-2 right-2"
              onClick={closeThisPopUP}
            />
            <MdWarning className="text-6xl text-[#ff6b00]" />

            <p className="text-primary  text-center font-bold text-xl mb-4">
              {content}
            </p>
            <button
              onClick={onClick}
              className="px-4 py-2 md:w-[45%] lg:w-[45%] w-[80%] mx-auto rounded-lg bg-primary hover:bg-transparent border border-transparent hover:border-primary text-white hover:text-primary"
            >
              {buttontext}
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
}
